/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicVerifyRouteImport } from './routes/_public/verify'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as AppOnboardingRouteImport } from './routes/_app/onboarding'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSequencesIndexRouteImport } from './routes/_app/sequences/index'
import { Route as AppSegmentsIndexRouteImport } from './routes/_app/segments/index'
import { Route as AppInboxIndexRouteImport } from './routes/_app/inbox/index'
import { Route as AppFlowsIndexRouteImport } from './routes/_app/flows/index'
import { Route as AppContactsIndexRouteImport } from './routes/_app/contacts/index'
import { Route as AppBroadcastsIndexRouteImport } from './routes/_app/broadcasts/index'
import { Route as AppAnalyticsIndexRouteImport } from './routes/_app/analytics/index'
import { Route as AppSettingsWorkspacesRouteImport } from './routes/_app/settings/workspaces'
import { Route as AppSettingsTagsRouteImport } from './routes/_app/settings/tags'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsInstagramRouteImport } from './routes/_app/settings/instagram'
import { Route as AppSettingsCustomFieldsRouteImport } from './routes/_app/settings/custom-fields'
import { Route as AppSettingsCannedRepliesRouteImport } from './routes/_app/settings/canned-replies'
import { Route as AppSettingsBlockListsRouteImport } from './routes/_app/settings/block-lists'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppSettingsAutoRepliesRouteImport } from './routes/_app/settings/auto-replies'
import { Route as AppSettingsActivityRouteImport } from './routes/_app/settings/activity'
import { Route as AppSequencesNewRouteImport } from './routes/_app/sequences/new'
import { Route as AppSequencesSequenceIdRouteImport } from './routes/_app/sequences/$sequenceId'
import { Route as AppSegmentsNewRouteImport } from './routes/_app/segments/new'
import { Route as AppSegmentsSegmentIdRouteImport } from './routes/_app/segments/$segmentId'
import { Route as AppInvitesAcceptRouteImport } from './routes/_app/invites/accept'
import { Route as AppInboxConversationIdRouteImport } from './routes/_app/inbox/$conversationId'
import { Route as AppFlowsTemplatesRouteImport } from './routes/_app/flows/templates'
import { Route as AppContactsContactIdRouteImport } from './routes/_app/contacts/$contactId'
import { Route as AppBroadcastsNewRouteImport } from './routes/_app/broadcasts/new'
import { Route as AppBroadcastsBroadcastIdRouteImport } from './routes/_app/broadcasts/$broadcastId'
import { Route as AppGrowthRefLinksIndexRouteImport } from './routes/_app/growth/ref-links/index'
import { Route as AppGrowthRefLinksNewRouteImport } from './routes/_app/growth/ref-links/new'
import { Route as AppGrowthRefLinksRefLinkIdRouteImport } from './routes/_app/growth/ref-links/$refLinkId'
import { Route as AppFlowsFlowIdEditRouteImport } from './routes/_app/flows/$flowId/edit'

const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicVerifyRoute = PublicVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRouteRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSequencesIndexRoute = AppSequencesIndexRouteImport.update({
  id: '/sequences/',
  path: '/sequences/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSegmentsIndexRoute = AppSegmentsIndexRouteImport.update({
  id: '/segments/',
  path: '/segments/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInboxIndexRoute = AppInboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFlowsIndexRoute = AppFlowsIndexRouteImport.update({
  id: '/flows/',
  path: '/flows/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContactsIndexRoute = AppContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBroadcastsIndexRoute = AppBroadcastsIndexRouteImport.update({
  id: '/broadcasts/',
  path: '/broadcasts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAnalyticsIndexRoute = AppAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsWorkspacesRoute = AppSettingsWorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTagsRoute = AppSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsInstagramRoute = AppSettingsInstagramRouteImport.update({
  id: '/instagram',
  path: '/instagram',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCustomFieldsRoute = AppSettingsCustomFieldsRouteImport.update({
  id: '/custom-fields',
  path: '/custom-fields',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCannedRepliesRoute =
  AppSettingsCannedRepliesRouteImport.update({
    id: '/canned-replies',
    path: '/canned-replies',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsBlockListsRoute = AppSettingsBlockListsRouteImport.update({
  id: '/block-lists',
  path: '/block-lists',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutoRepliesRoute = AppSettingsAutoRepliesRouteImport.update({
  id: '/auto-replies',
  path: '/auto-replies',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsActivityRoute = AppSettingsActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSequencesNewRoute = AppSequencesNewRouteImport.update({
  id: '/sequences/new',
  path: '/sequences/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSequencesSequenceIdRoute = AppSequencesSequenceIdRouteImport.update({
  id: '/sequences/$sequenceId',
  path: '/sequences/$sequenceId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSegmentsNewRoute = AppSegmentsNewRouteImport.update({
  id: '/segments/new',
  path: '/segments/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSegmentsSegmentIdRoute = AppSegmentsSegmentIdRouteImport.update({
  id: '/segments/$segmentId',
  path: '/segments/$segmentId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInvitesAcceptRoute = AppInvitesAcceptRouteImport.update({
  id: '/invites/accept',
  path: '/invites/accept',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInboxConversationIdRoute = AppInboxConversationIdRouteImport.update({
  id: '/inbox/$conversationId',
  path: '/inbox/$conversationId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFlowsTemplatesRoute = AppFlowsTemplatesRouteImport.update({
  id: '/flows/templates',
  path: '/flows/templates',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContactsContactIdRoute = AppContactsContactIdRouteImport.update({
  id: '/contacts/$contactId',
  path: '/contacts/$contactId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBroadcastsNewRoute = AppBroadcastsNewRouteImport.update({
  id: '/broadcasts/new',
  path: '/broadcasts/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBroadcastsBroadcastIdRoute =
  AppBroadcastsBroadcastIdRouteImport.update({
    id: '/broadcasts/$broadcastId',
    path: '/broadcasts/$broadcastId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppGrowthRefLinksIndexRoute = AppGrowthRefLinksIndexRouteImport.update({
  id: '/growth/ref-links/',
  path: '/growth/ref-links/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGrowthRefLinksNewRoute = AppGrowthRefLinksNewRouteImport.update({
  id: '/growth/ref-links/new',
  path: '/growth/ref-links/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGrowthRefLinksRefLinkIdRoute =
  AppGrowthRefLinksRefLinkIdRouteImport.update({
    id: '/growth/ref-links/$refLinkId',
    path: '/growth/ref-links/$refLinkId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppFlowsFlowIdEditRoute = AppFlowsFlowIdEditRouteImport.update({
  id: '/flows/$flowId/edit',
  path: '/flows/$flowId/edit',
  getParentRoute: () => AppRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/onboarding': typeof AppOnboardingRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify': typeof PublicVerifyRoute
  '/broadcasts/$broadcastId': typeof AppBroadcastsBroadcastIdRoute
  '/broadcasts/new': typeof AppBroadcastsNewRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/flows/templates': typeof AppFlowsTemplatesRoute
  '/inbox/$conversationId': typeof AppInboxConversationIdRoute
  '/invites/accept': typeof AppInvitesAcceptRoute
  '/segments/$segmentId': typeof AppSegmentsSegmentIdRoute
  '/segments/new': typeof AppSegmentsNewRoute
  '/sequences/$sequenceId': typeof AppSequencesSequenceIdRoute
  '/sequences/new': typeof AppSequencesNewRoute
  '/settings/activity': typeof AppSettingsActivityRoute
  '/settings/auto-replies': typeof AppSettingsAutoRepliesRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/block-lists': typeof AppSettingsBlockListsRoute
  '/settings/canned-replies': typeof AppSettingsCannedRepliesRoute
  '/settings/custom-fields': typeof AppSettingsCustomFieldsRoute
  '/settings/instagram': typeof AppSettingsInstagramRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/workspaces': typeof AppSettingsWorkspacesRoute
  '/analytics/': typeof AppAnalyticsIndexRoute
  '/broadcasts/': typeof AppBroadcastsIndexRoute
  '/contacts/': typeof AppContactsIndexRoute
  '/flows/': typeof AppFlowsIndexRoute
  '/inbox/': typeof AppInboxIndexRoute
  '/segments/': typeof AppSegmentsIndexRoute
  '/sequences/': typeof AppSequencesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/flows/$flowId/edit': typeof AppFlowsFlowIdEditRoute
  '/growth/ref-links/$refLinkId': typeof AppGrowthRefLinksRefLinkIdRoute
  '/growth/ref-links/new': typeof AppGrowthRefLinksNewRoute
  '/growth/ref-links/': typeof AppGrowthRefLinksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/onboarding': typeof AppOnboardingRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/signup': typeof PublicSignupRoute
  '/verify': typeof PublicVerifyRoute
  '/broadcasts/$broadcastId': typeof AppBroadcastsBroadcastIdRoute
  '/broadcasts/new': typeof AppBroadcastsNewRoute
  '/contacts/$contactId': typeof AppContactsContactIdRoute
  '/flows/templates': typeof AppFlowsTemplatesRoute
  '/inbox/$conversationId': typeof AppInboxConversationIdRoute
  '/invites/accept': typeof AppInvitesAcceptRoute
  '/segments/$segmentId': typeof AppSegmentsSegmentIdRoute
  '/segments/new': typeof AppSegmentsNewRoute
  '/sequences/$sequenceId': typeof AppSequencesSequenceIdRoute
  '/sequences/new': typeof AppSequencesNewRoute
  '/settings/activity': typeof AppSettingsActivityRoute
  '/settings/auto-replies': typeof AppSettingsAutoRepliesRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/block-lists': typeof AppSettingsBlockListsRoute
  '/settings/canned-replies': typeof AppSettingsCannedRepliesRoute
  '/settings/custom-fields': typeof AppSettingsCustomFieldsRoute
  '/settings/instagram': typeof AppSettingsInstagramRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/workspaces': typeof AppSettingsWorkspacesRoute
  '/analytics': typeof AppAnalyticsIndexRoute
  '/broadcasts': typeof AppBroadcastsIndexRoute
  '/contacts': typeof AppContactsIndexRoute
  '/flows': typeof AppFlowsIndexRoute
  '/inbox': typeof AppInboxIndexRoute
  '/segments': typeof AppSegmentsIndexRoute
  '/sequences': typeof AppSequencesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/flows/$flowId/edit': typeof AppFlowsFlowIdEditRoute
  '/growth/ref-links/$refLinkId': typeof AppGrowthRefLinksRefLinkIdRoute
  '/growth/ref-links/new': typeof AppGrowthRefLinksNewRoute
  '/growth/ref-links': typeof AppGrowthRefLinksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/onboarding': typeof AppOnboardingRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/verify': typeof PublicVerifyRoute
  '/_app/broadcasts/$broadcastId': typeof AppBroadcastsBroadcastIdRoute
  '/_app/broadcasts/new': typeof AppBroadcastsNewRoute
  '/_app/contacts/$contactId': typeof AppContactsContactIdRoute
  '/_app/flows/templates': typeof AppFlowsTemplatesRoute
  '/_app/inbox/$conversationId': typeof AppInboxConversationIdRoute
  '/_app/invites/accept': typeof AppInvitesAcceptRoute
  '/_app/segments/$segmentId': typeof AppSegmentsSegmentIdRoute
  '/_app/segments/new': typeof AppSegmentsNewRoute
  '/_app/sequences/$sequenceId': typeof AppSequencesSequenceIdRoute
  '/_app/sequences/new': typeof AppSequencesNewRoute
  '/_app/settings/activity': typeof AppSettingsActivityRoute
  '/_app/settings/auto-replies': typeof AppSettingsAutoRepliesRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/block-lists': typeof AppSettingsBlockListsRoute
  '/_app/settings/canned-replies': typeof AppSettingsCannedRepliesRoute
  '/_app/settings/custom-fields': typeof AppSettingsCustomFieldsRoute
  '/_app/settings/instagram': typeof AppSettingsInstagramRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/tags': typeof AppSettingsTagsRoute
  '/_app/settings/workspaces': typeof AppSettingsWorkspacesRoute
  '/_app/analytics/': typeof AppAnalyticsIndexRoute
  '/_app/broadcasts/': typeof AppBroadcastsIndexRoute
  '/_app/contacts/': typeof AppContactsIndexRoute
  '/_app/flows/': typeof AppFlowsIndexRoute
  '/_app/inbox/': typeof AppInboxIndexRoute
  '/_app/segments/': typeof AppSegmentsIndexRoute
  '/_app/sequences/': typeof AppSequencesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/flows/$flowId/edit': typeof AppFlowsFlowIdEditRoute
  '/_app/growth/ref-links/$refLinkId': typeof AppGrowthRefLinksRefLinkIdRoute
  '/_app/growth/ref-links/new': typeof AppGrowthRefLinksNewRoute
  '/_app/growth/ref-links/': typeof AppGrowthRefLinksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/dashboard'
    | '/onboarding'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify'
    | '/broadcasts/$broadcastId'
    | '/broadcasts/new'
    | '/contacts/$contactId'
    | '/flows/templates'
    | '/inbox/$conversationId'
    | '/invites/accept'
    | '/segments/$segmentId'
    | '/segments/new'
    | '/sequences/$sequenceId'
    | '/sequences/new'
    | '/settings/activity'
    | '/settings/auto-replies'
    | '/settings/billing'
    | '/settings/block-lists'
    | '/settings/canned-replies'
    | '/settings/custom-fields'
    | '/settings/instagram'
    | '/settings/members'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/workspaces'
    | '/analytics/'
    | '/broadcasts/'
    | '/contacts/'
    | '/flows/'
    | '/inbox/'
    | '/segments/'
    | '/sequences/'
    | '/settings/'
    | '/flows/$flowId/edit'
    | '/growth/ref-links/$refLinkId'
    | '/growth/ref-links/new'
    | '/growth/ref-links/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/onboarding'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify'
    | '/broadcasts/$broadcastId'
    | '/broadcasts/new'
    | '/contacts/$contactId'
    | '/flows/templates'
    | '/inbox/$conversationId'
    | '/invites/accept'
    | '/segments/$segmentId'
    | '/segments/new'
    | '/sequences/$sequenceId'
    | '/sequences/new'
    | '/settings/activity'
    | '/settings/auto-replies'
    | '/settings/billing'
    | '/settings/block-lists'
    | '/settings/canned-replies'
    | '/settings/custom-fields'
    | '/settings/instagram'
    | '/settings/members'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/workspaces'
    | '/analytics'
    | '/broadcasts'
    | '/contacts'
    | '/flows'
    | '/inbox'
    | '/segments'
    | '/sequences'
    | '/settings'
    | '/flows/$flowId/edit'
    | '/growth/ref-links/$refLinkId'
    | '/growth/ref-links/new'
    | '/growth/ref-links'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_public'
    | '/_app/settings'
    | '/_app/dashboard'
    | '/_app/onboarding'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/reset-password'
    | '/_public/signup'
    | '/_public/verify'
    | '/_app/broadcasts/$broadcastId'
    | '/_app/broadcasts/new'
    | '/_app/contacts/$contactId'
    | '/_app/flows/templates'
    | '/_app/inbox/$conversationId'
    | '/_app/invites/accept'
    | '/_app/segments/$segmentId'
    | '/_app/segments/new'
    | '/_app/sequences/$sequenceId'
    | '/_app/sequences/new'
    | '/_app/settings/activity'
    | '/_app/settings/auto-replies'
    | '/_app/settings/billing'
    | '/_app/settings/block-lists'
    | '/_app/settings/canned-replies'
    | '/_app/settings/custom-fields'
    | '/_app/settings/instagram'
    | '/_app/settings/members'
    | '/_app/settings/security'
    | '/_app/settings/tags'
    | '/_app/settings/workspaces'
    | '/_app/analytics/'
    | '/_app/broadcasts/'
    | '/_app/contacts/'
    | '/_app/flows/'
    | '/_app/inbox/'
    | '/_app/segments/'
    | '/_app/sequences/'
    | '/_app/settings/'
    | '/_app/flows/$flowId/edit'
    | '/_app/growth/ref-links/$refLinkId'
    | '/_app/growth/ref-links/new'
    | '/_app/growth/ref-links/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/verify': {
      id: '/_public/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof PublicVerifyRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_app/onboarding': {
      id: '/_app/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/sequences/': {
      id: '/_app/sequences/'
      path: '/sequences'
      fullPath: '/sequences/'
      preLoaderRoute: typeof AppSequencesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/segments/': {
      id: '/_app/segments/'
      path: '/segments'
      fullPath: '/segments/'
      preLoaderRoute: typeof AppSegmentsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/inbox/': {
      id: '/_app/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof AppInboxIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/flows/': {
      id: '/_app/flows/'
      path: '/flows'
      fullPath: '/flows/'
      preLoaderRoute: typeof AppFlowsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/contacts/': {
      id: '/_app/contacts/'
      path: '/contacts'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AppContactsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/broadcasts/': {
      id: '/_app/broadcasts/'
      path: '/broadcasts'
      fullPath: '/broadcasts/'
      preLoaderRoute: typeof AppBroadcastsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/analytics/': {
      id: '/_app/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AppAnalyticsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/workspaces': {
      id: '/_app/settings/workspaces'
      path: '/workspaces'
      fullPath: '/settings/workspaces'
      preLoaderRoute: typeof AppSettingsWorkspacesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tags': {
      id: '/_app/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AppSettingsTagsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/instagram': {
      id: '/_app/settings/instagram'
      path: '/instagram'
      fullPath: '/settings/instagram'
      preLoaderRoute: typeof AppSettingsInstagramRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/custom-fields': {
      id: '/_app/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof AppSettingsCustomFieldsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/canned-replies': {
      id: '/_app/settings/canned-replies'
      path: '/canned-replies'
      fullPath: '/settings/canned-replies'
      preLoaderRoute: typeof AppSettingsCannedRepliesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/block-lists': {
      id: '/_app/settings/block-lists'
      path: '/block-lists'
      fullPath: '/settings/block-lists'
      preLoaderRoute: typeof AppSettingsBlockListsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-replies': {
      id: '/_app/settings/auto-replies'
      path: '/auto-replies'
      fullPath: '/settings/auto-replies'
      preLoaderRoute: typeof AppSettingsAutoRepliesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/activity': {
      id: '/_app/settings/activity'
      path: '/activity'
      fullPath: '/settings/activity'
      preLoaderRoute: typeof AppSettingsActivityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/sequences/new': {
      id: '/_app/sequences/new'
      path: '/sequences/new'
      fullPath: '/sequences/new'
      preLoaderRoute: typeof AppSequencesNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sequences/$sequenceId': {
      id: '/_app/sequences/$sequenceId'
      path: '/sequences/$sequenceId'
      fullPath: '/sequences/$sequenceId'
      preLoaderRoute: typeof AppSequencesSequenceIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/segments/new': {
      id: '/_app/segments/new'
      path: '/segments/new'
      fullPath: '/segments/new'
      preLoaderRoute: typeof AppSegmentsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/segments/$segmentId': {
      id: '/_app/segments/$segmentId'
      path: '/segments/$segmentId'
      fullPath: '/segments/$segmentId'
      preLoaderRoute: typeof AppSegmentsSegmentIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/invites/accept': {
      id: '/_app/invites/accept'
      path: '/invites/accept'
      fullPath: '/invites/accept'
      preLoaderRoute: typeof AppInvitesAcceptRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/inbox/$conversationId': {
      id: '/_app/inbox/$conversationId'
      path: '/inbox/$conversationId'
      fullPath: '/inbox/$conversationId'
      preLoaderRoute: typeof AppInboxConversationIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/flows/templates': {
      id: '/_app/flows/templates'
      path: '/flows/templates'
      fullPath: '/flows/templates'
      preLoaderRoute: typeof AppFlowsTemplatesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/contacts/$contactId': {
      id: '/_app/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AppContactsContactIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/broadcasts/new': {
      id: '/_app/broadcasts/new'
      path: '/broadcasts/new'
      fullPath: '/broadcasts/new'
      preLoaderRoute: typeof AppBroadcastsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/broadcasts/$broadcastId': {
      id: '/_app/broadcasts/$broadcastId'
      path: '/broadcasts/$broadcastId'
      fullPath: '/broadcasts/$broadcastId'
      preLoaderRoute: typeof AppBroadcastsBroadcastIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/growth/ref-links/': {
      id: '/_app/growth/ref-links/'
      path: '/growth/ref-links'
      fullPath: '/growth/ref-links/'
      preLoaderRoute: typeof AppGrowthRefLinksIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/growth/ref-links/new': {
      id: '/_app/growth/ref-links/new'
      path: '/growth/ref-links/new'
      fullPath: '/growth/ref-links/new'
      preLoaderRoute: typeof AppGrowthRefLinksNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/growth/ref-links/$refLinkId': {
      id: '/_app/growth/ref-links/$refLinkId'
      path: '/growth/ref-links/$refLinkId'
      fullPath: '/growth/ref-links/$refLinkId'
      preLoaderRoute: typeof AppGrowthRefLinksRefLinkIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/flows/$flowId/edit': {
      id: '/_app/flows/$flowId/edit'
      path: '/flows/$flowId/edit'
      fullPath: '/flows/$flowId/edit'
      preLoaderRoute: typeof AppFlowsFlowIdEditRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppSettingsRouteRouteChildren {
  AppSettingsActivityRoute: typeof AppSettingsActivityRoute
  AppSettingsAutoRepliesRoute: typeof AppSettingsAutoRepliesRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsBlockListsRoute: typeof AppSettingsBlockListsRoute
  AppSettingsCannedRepliesRoute: typeof AppSettingsCannedRepliesRoute
  AppSettingsCustomFieldsRoute: typeof AppSettingsCustomFieldsRoute
  AppSettingsInstagramRoute: typeof AppSettingsInstagramRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTagsRoute: typeof AppSettingsTagsRoute
  AppSettingsWorkspacesRoute: typeof AppSettingsWorkspacesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsActivityRoute: AppSettingsActivityRoute,
  AppSettingsAutoRepliesRoute: AppSettingsAutoRepliesRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsBlockListsRoute: AppSettingsBlockListsRoute,
  AppSettingsCannedRepliesRoute: AppSettingsCannedRepliesRoute,
  AppSettingsCustomFieldsRoute: AppSettingsCustomFieldsRoute,
  AppSettingsInstagramRoute: AppSettingsInstagramRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTagsRoute: AppSettingsTagsRoute,
  AppSettingsWorkspacesRoute: AppSettingsWorkspacesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppBroadcastsBroadcastIdRoute: typeof AppBroadcastsBroadcastIdRoute
  AppBroadcastsNewRoute: typeof AppBroadcastsNewRoute
  AppContactsContactIdRoute: typeof AppContactsContactIdRoute
  AppFlowsTemplatesRoute: typeof AppFlowsTemplatesRoute
  AppInboxConversationIdRoute: typeof AppInboxConversationIdRoute
  AppInvitesAcceptRoute: typeof AppInvitesAcceptRoute
  AppSegmentsSegmentIdRoute: typeof AppSegmentsSegmentIdRoute
  AppSegmentsNewRoute: typeof AppSegmentsNewRoute
  AppSequencesSequenceIdRoute: typeof AppSequencesSequenceIdRoute
  AppSequencesNewRoute: typeof AppSequencesNewRoute
  AppAnalyticsIndexRoute: typeof AppAnalyticsIndexRoute
  AppBroadcastsIndexRoute: typeof AppBroadcastsIndexRoute
  AppContactsIndexRoute: typeof AppContactsIndexRoute
  AppFlowsIndexRoute: typeof AppFlowsIndexRoute
  AppInboxIndexRoute: typeof AppInboxIndexRoute
  AppSegmentsIndexRoute: typeof AppSegmentsIndexRoute
  AppSequencesIndexRoute: typeof AppSequencesIndexRoute
  AppFlowsFlowIdEditRoute: typeof AppFlowsFlowIdEditRoute
  AppGrowthRefLinksRefLinkIdRoute: typeof AppGrowthRefLinksRefLinkIdRoute
  AppGrowthRefLinksNewRoute: typeof AppGrowthRefLinksNewRoute
  AppGrowthRefLinksIndexRoute: typeof AppGrowthRefLinksIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppBroadcastsBroadcastIdRoute: AppBroadcastsBroadcastIdRoute,
  AppBroadcastsNewRoute: AppBroadcastsNewRoute,
  AppContactsContactIdRoute: AppContactsContactIdRoute,
  AppFlowsTemplatesRoute: AppFlowsTemplatesRoute,
  AppInboxConversationIdRoute: AppInboxConversationIdRoute,
  AppInvitesAcceptRoute: AppInvitesAcceptRoute,
  AppSegmentsSegmentIdRoute: AppSegmentsSegmentIdRoute,
  AppSegmentsNewRoute: AppSegmentsNewRoute,
  AppSequencesSequenceIdRoute: AppSequencesSequenceIdRoute,
  AppSequencesNewRoute: AppSequencesNewRoute,
  AppAnalyticsIndexRoute: AppAnalyticsIndexRoute,
  AppBroadcastsIndexRoute: AppBroadcastsIndexRoute,
  AppContactsIndexRoute: AppContactsIndexRoute,
  AppFlowsIndexRoute: AppFlowsIndexRoute,
  AppInboxIndexRoute: AppInboxIndexRoute,
  AppSegmentsIndexRoute: AppSegmentsIndexRoute,
  AppSequencesIndexRoute: AppSequencesIndexRoute,
  AppFlowsFlowIdEditRoute: AppFlowsFlowIdEditRoute,
  AppGrowthRefLinksRefLinkIdRoute: AppGrowthRefLinksRefLinkIdRoute,
  AppGrowthRefLinksNewRoute: AppGrowthRefLinksNewRoute,
  AppGrowthRefLinksIndexRoute: AppGrowthRefLinksIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicVerifyRoute: typeof PublicVerifyRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicVerifyRoute: PublicVerifyRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
